import React, { useCallback, useEffect, useState, useContext } from 'react'
import FavoriteContext from 'context/favoriteContext'
import { useUser } from 'providers/UserProvider'

import { Row } from 'components/v2/Grid'
import { BookmarkSimple } from 'phosphor-react'
import { Text } from 'components/v2/Text'

import { postLikeProfessionalId } from 'services/favorites'

import { favoriteProfessional } from 'components/shared/DataLayer'

const BookmarkButton = ({ professionalId, professionalSlug, isLiked }) => {
  const [isMarked, setIsMarked] = useState(false)

  const { isUserLoggedIn } = useUser()
  const { likeProfessionals, setLikeProfessionals } = useContext(FavoriteContext)

  useEffect(() => {
    isUserLoggedIn
      ? setIsMarked(isLiked)
      : setIsMarked(likeProfessionals?.some(professional => professional.id === professionalId))
  }, [isLiked, isUserLoggedIn])

  const handleMarked = useCallback(
    async like => {
      setIsMarked(like)

      if (!isUserLoggedIn) {
        if (likeProfessionals?.some(professional => professional.id === professionalId)) {
          favoriteProfessional({
            favoriteEvent: 'unlike',
            variant: 'PRINCIPAL',
            professionalId: professionalId,
            professionalSlug: professionalSlug
          })
          setLikeProfessionals(
            likeProfessionals.filter(professional => professional.id !== professionalId)
          )
        }

        favoriteProfessional({
          favoriteEvent: 'like',
          variant: 'PRINCIPAL',
          professionalId: professionalId,
          professionalSlug: professionalSlug
        })

        const professional = { id: professionalId, slug: professionalSlug }
        setLikeProfessionals((likeProfessionals || []).concat(professional))
        return
      }

      const eventLabel = like ? 'like' : 'unlike'

      favoriteProfessional({
        favoriteEvent: eventLabel,
        variant: 'PRINCIPAL',
        professionalId: professionalId,
        professionalSlug: professionalSlug
      })

      await postLikeProfessionalId({ professional_id: professionalId })
    },
    [isUserLoggedIn, likeProfessionals, professionalId, professionalSlug]
  )

  return (
    <Row
      as='a'
      alignItems='center'
      justifyContent='center'
      onClick={() => handleMarked(!isMarked)}
      cursor='pointer'
      px='8px'
      py='4px'
      border='1px solid #D9D9D9'
      borderRadius='4px'
      height='42px'
      display={['none', 'none', 'flex']}
    >
      <BookmarkSimple size={20} weight={isMarked ? 'fill' : 'regular'} color='#FF7708' />
      <Text variant='small' lineHeight='24px' color='black' fontWeight='400'>
        {isMarked ? 'Favoritado' : 'Favoritar'}
      </Text>
    </Row>
  )
}

export { BookmarkButton }
